import { ListCard } from "@components/styles/dataDisplay";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { HistoricalSkeletonContainer } from "./style";

const HistoricalSkeleton = () => {
  return (
    <div>
      <Skeleton style={{ width: 250 }} />
      <ListCard style={{ marginTop: 12 }} border>
        <HistoricalSkeletonContainer>
          <div className="skeletonData">
            <Skeleton />
          </div>
          <div className="skeletonBody">
            <Skeleton />
            <Skeleton height={30} />
          </div>
        </HistoricalSkeletonContainer>
        <HistoricalSkeletonContainer>
          <div className="skeletonData">
            <Skeleton />
          </div>
          <div className="skeletonBody">
            <Skeleton />
            <Skeleton height={30} />
          </div>
        </HistoricalSkeletonContainer>
      </ListCard>
    </div>
  );
};

export default HistoricalSkeleton;
